import { render, staticRenderFns } from "./hotCourse.vue?vue&type=template&id=2db78ce6&scoped=true&"
import script from "./hotCourse.vue?vue&type=script&lang=js&"
export * from "./hotCourse.vue?vue&type=script&lang=js&"
import style0 from "./hotCourse.vue?vue&type=style&index=0&id=2db78ce6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db78ce6",
  null
  
)

export default component.exports